import React from 'react';

const Input = ({ value }) => <input disabled className="form-control" value={value} />;

export const Textarea = ({ value }) => (
  <textarea disabled className="form-control" value={value} rows={3} />
);

export default Input;
